/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';

const AppSpinner = () => {
    return (
        <div className="relative app-spinner app-spinner-mini">
            <div
                className="border-t-mono-1000! border-b-transparent! border-l-transparent! border-r-transparent!"></div>
            <div
                className="border-t-mono-1000! border-b-transparent! border-l-transparent! border-r-transparent!"></div>
            <div
                className="border-t-mono-1000! border-b-transparent! border-l-transparent! border-r-transparent!"></div>
            <div
                className="border-t-mono-1000! border-b-transparent! border-l-transparent! border-r-transparent!"></div>
        </div>
    );
}

export default AppSpinner;
